import { createApp } from 'vue';
import { createRouter, createWebHistory} from 'vue-router';

import App from './App.vue';
import '../css/style.css';
import '../css/form.css';
import MyResume from './components/MyResume.vue';
import MyFrenchForm from './components/MyFrenchForm.vue';
import MyEnglishResume from './components/MyEnglishResume.vue';
import MyEnglishForm from './components/MyEnglishForm.vue';



const router = createRouter({
history: createWebHistory(),
routes: [
    {path: '/', redirect:  '/myfrenchresume'},
    {path: '/myfrenchresume', component: MyResume},
    {path: '/myfrenchform', component: MyFrenchForm},
    {path: '/myenglishresume', component: MyEnglishResume},
    {path: '/myenglishform', component: MyEnglishForm},

]
});



const app =createApp(App);
app.use(router)
app.mount('#app');

